var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMp4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 701,
    viewBox: "0 0 500 701",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M437.501 1.00087H137.501C135.861 0.980888 134.236 1.30421 132.729 1.95005C131.222 2.59588 129.867 3.54994 128.751 4.75088L3.75088 129.751C2.54994 130.867 1.59588 132.222 0.950041 133.729C0.304204 135.236 -0.0191124 136.861 0.000873117 138.501V638.501C0.000873117 655.077 6.58568 670.974 18.3067 682.695C30.0277 694.416 45.9248 701.001 62.5009 701.001H437.501C454.077 701.001 469.974 694.416 481.695 682.695C493.416 670.974 500.001 655.077 500.001 638.501V63.5009C500.001 46.9248 493.416 31.0277 481.695 19.3067C469.974 7.58568 454.077 1.00087 437.501 1.00087Z",
    fill: "url(#paint0_linear_2267_389)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M143.359 1.04767C141.106 0.02656 138.588 -0.257327 136.164 0.236459C133.74 0.730245 131.533 1.97651 129.859 3.79766L4.8589 128.798C2.64467 130.401 1.05877 132.726 0.374284 135.373C-0.310196 138.019 -0.0504147 140.822 1.1089 143.298C2.10581 145.745 3.85262 147.813 6.09846 149.206C8.34431 150.598 10.9737 151.243 13.6089 151.048H88.6089C96.8165 151.048 104.944 149.431 112.527 146.29C120.109 143.149 126.999 138.546 132.803 132.742C138.607 126.938 143.21 120.048 146.351 112.465C149.492 104.883 151.109 96.7553 151.109 88.5477V13.5477C151.304 10.9124 150.659 8.28308 149.267 6.03723C147.874 3.79139 145.806 2.04458 143.359 1.04767Z",
    fill: "url(#paint1_linear_2267_389)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M258.324 476H164.5C117.588 476 102 444.824 102 413.5V288.5C102 241.588 117.588 226 164.5 226H258.324C305.236 226 320.824 241.588 320.824 288.5V413.5C320.824 460.412 305.088 476 258.324 476Z",
    stroke: "white",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M362.098 426.714L320.828 397.765V304.089L362.098 275.14C382.288 261.037 398.916 269.647 398.916 294.439V407.563C398.916 432.355 382.288 440.965 362.098 426.714Z",
    stroke: "white",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M243.034 336.154C255.332 336.154 265.302 326.184 265.302 313.885C265.302 301.587 255.332 291.617 243.034 291.617C230.735 291.617 220.765 301.587 220.765 313.885C220.765 326.184 230.735 336.154 243.034 336.154Z",
    stroke: "white",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2267_389",
    x1: 16.2509,
    y1: 117.251,
    x2: 531.751,
    y2: 632.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF6461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E83D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2267_389",
    x1: 1.1089,
    y1: 76.0477,
    x2: 151.109,
    y2: 76.0477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF6461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E83D3D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp4);
export default __webpack_public_path__ + "static/media/mp4.582e976cff2b0b3f7b1478e1fc146ad4.svg";
export { ForwardRef as ReactComponent };